import { Configuration, PopupRequest } from '@azure/msal-browser';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1_SignUpOrSignIn",
    editProfile: "B2C_1_ProfileEdit",
  },
  authorities: {
    signUpSignIn: {
      authority:
        process.env.REACT_APP_MSAL_AUTHORITY_SIGN_UP_OR_SIGN_IN,
    },
    editProfile: {
      authority:
        process.env.REACT_APP_MSAL_AUTHORITY_EDIT_PROFILE,
    },
  },
  authorityDomain: process.env.REACT_APP_MSAL_AUTHORITY_DOMAIN ?? "AUTHORITY_DOMAIN_NOT_SET",
};

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID ?? "CLIENT_ID_NOT_SET", // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: "/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

export const protectedResources = {
  apiTodoList: {
    scopes: {
      read: [
        process.env.REACT_APP_MSAL_SCOPE ?? "SCOPE_NOT_SET",
      ],
      write: [
        process.env.REACT_APP_MSAL_SCOPE ?? "SCOPE_NOT_SET",
      ],
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: [
    ...protectedResources.apiTodoList.scopes.read,
    ...protectedResources.apiTodoList.scopes.write,
  ],
};
